import request from "service/request";

/* POST CONTACT US API */
export const postContactUsApi = async (data) => {
  try {
    const response = await request.post(`/contact-us`, data);
    return response.data;
  } catch (error) {
    console.error("Error occurred in API:", error);
    throw error;
  }
};
